<template>
  <div>
    <div class="layout favorites-page">
      <div class="layout-item grow">
        <div class="map" ref="favorites-map">
          <div class="custom-control">
            <a @click="toggle3d()">
              <img src="@/assets/icons/td.svg" alt="">
            </a>
          </div>

          <div class="custom-control mt-6">
            <a @click="reset()">
              <i class="fas fa-sync"></i>
            </a>
          </div>

          <app-map-label :labels="{available: false, sold: false, favorites: true, spec: false}"></app-map-label>
        </div>
      </div>
      <div class="layout-item direction-panel" v-if="route">
        <div class="heading">
          <p>Direction from Welcome Center</p>
          <button class="delete" @click="removeDirection"></button>
        </div>
        <div class="steps" v-if="route && route.legs && route.legs.length && route.legs[0].steps">
          <table class="table is-fullwidth">
            <tr v-for="steps in route.legs[0].steps">
              <td>
                <img v-if="steps['icon']" :src="require('@/assets/diving_icons/' + steps.icon)" alt="">
              </td>
              <td class="instruction">{{ steps.maneuver.instruction }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Map from "@/mixins/favorites/FavoriteMap";
import Direction from "@/mixins/map/Direction";
import Common from "@/mixins/Common";
import Loading from "@/components/journey/Loading";
import MapLabel from "@/components/journey/MapLabel";

export default {
  name: 'app-community-map',
  mixins: [Map, Direction, Common],
  components: {
    'app-loading': Loading,
    'app-map-label': MapLabel
  },
  data() {
    return {
      initiatedMap: false,
      masterplanConfig: null,
      sub: null,
      isPitched: true
    }
  },
  props: {
    favoriteHnl: {
      type: Array
    },
  },
  watch: {
    favoriteHnl: {
      handler(val, oldval) {
        if (val) {
          this.mapLots();
        }
      },
      deep: true
    }
  },
  beforeDestroy() {
    if (this.map) {
      this.map.remove();
    }
    this.sub();
  },
  mounted: function () {
    this.masterplanConfig = this.$store.getters.masterplanConfig;
    this.fetchMasterplanConfig();
  },
  created() {
  },
  methods: {
    fetchMasterplanConfig: function () {
      this.sub = this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'setMasterplanConfig') {
          this.masterplanConfig = this.$store.getters.masterplanConfig;
          this.loadMap();
        }
      })
      this.$store.dispatch('fetchMasterplanConfig');
    },

    mapLots() {
      // const ids = this.favoriteHnl.map(item => item.lotproductcpid);
      // this.lotIds = ids.filter((value, index, self) => {
      //   return self.indexOf(value) === index
      // });

      if (!this.initiatedMap) {
        return this.loadMap();
      }

      this.filterMapLots(this.favoriteHnl);
    },

    loadMap: function () {
      if (!this.initiatedMap && this.masterplanConfig && this.favoriteHnl) {
        this.loading = false;
        this.initiatedMap = true;
        this.initMap(this.masterplanConfig, this.favoriteHnl);
      }
    },

    toggle3d: function () {
      const pitch = this.isPitched ? 0 : 60
      this.isPitched = !this.isPitched;
      this.map.flyTo({
        pitch: pitch
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/favorites/FavoritesMap.vue